import AppDispatcher from '../dispatcher/AppDispatcher';
import HotelConstants from '../constants/HotelConstants';
import SearchStore from '../stores/SearchStore';
import ResultsStore from '../stores/ResultsStore';
import Ajax from '../utils/Ajax';

const LazyRecheckActions = {
    start: function (clicked_deal, hotel_id) {
        const token = SearchStore.getHotelToken() || SearchStore.getToken();
        const all_deals = ResultsStore.getHotelDealsById(hotel_id) || [];

        const lazy_peer_deals = all_deals.filter(
            (d) => d.superseded_group_id === clicked_deal.superseded_group_id && d.id !== clicked_deal.id,
        );

        const all_lazy_deals = [clicked_deal, ...lazy_peer_deals];
        const all_lazy_ids = all_lazy_deals.filter((d) => d.is_lazy_recheck).map((d) => d.id);

        AppDispatcher.handleAction({
            actionType: HotelConstants.LAZY_RECHECK_START,
            data: { clicked_deal, lazy_deals: all_lazy_deals, hotel_id },
        });

        Ajax.lazyRecheckDeals({ token, hotel_id, deal_ids: all_lazy_ids })
            .done(function (res) {
                AppDispatcher.handleAction({
                    actionType: HotelConstants.LAZY_RECHECK_REQUESTED,
                    data: { listener_id: res.listener_id, wait_time: res.wait_time },
                });
            })
            .fail(function (err) {
                console.error('LazyRecheckActions.start failed', err);
                if (err?.status === 410) {
                    AppDispatcher.handleAction({
                        actionType: HotelConstants.LAZY_RECHECK_EXPIRED,
                    });
                    return;
                }
                AppDispatcher.handleAction({
                    actionType: HotelConstants.LAZY_RECHECK_NO_AVAILABILITY,
                    data: {},
                });
            });
    },

    reset: function () {
        AppDispatcher.handleAction({
            actionType: HotelConstants.LAZY_RECHECK_RESET,
            data: {},
        });
    },

    confirmPriceChange: function () {
        AppDispatcher.handleAction({
            actionType: HotelConstants.LAZY_RECHECK_CONFIRM_PRICE_CHANGE,
            data: {},
        });
    },
};

export default LazyRecheckActions;
